import React, { Component } from "react";

import { Container, Row, Col, Table, Form } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';
class DataTableMasterDataTargetIndustries extends Component {

    render() {

        let props = this.props;

        let { onSetEdit, onDropDownChange, onReorder, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.status !== '0') { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p">#</th>
                                        <th className="th-width-auto">อุตสาหกรรม</th>
                                        <th className="th-width-75p">ลำดับ</th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-width-150p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {
                                        
                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                        rowId++;

                                        let del = true;
                                        if (row.status === '0') { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="text-truncate" title={row.name}>
                                                        {row.name}
                                                        {row.genIndustriesCode && (
                                                            <font className="ms-2">({row.genIndustriesCode})</font>
                                                        )}
                                                    </td>
                                                    <td>{row.seq}</td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="up-direction" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onReorder({id: row.id, sequenceField: 'seq', filter: [], direction: 'up'})} 
                                                            order={{direction: 'up', row: rowId, rows: DataTable.pagination.totalRows}}
                                                            operation={Operation}
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="down-direction" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onReorder({id: row.id, sequenceField: 'seq', filter: [], direction: 'down'})}
                                                            order={{direction: 'down', row: rowId, rows: DataTable.pagination.totalRows}}
                                                            operation={Operation}
                                                        />
                                                    </td>
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'status', value: row.status}}
                                                            option={{source: 'options', section: 'status', item: 'default'}}
                                                            callback={(e, element) => onDropDownChange(e, element, {key: 'id', value: row.id} )} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableMasterDataTargetIndustries;
